// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-line-data-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.22803 13.4474C6.22803 13.4474 8.95521 8.07109 11.4772 8.78599C13.9991 9.50088 13.0206 12.5277 15.5099 13.2643C17.9991 14.0009 20.7439 8.61621 20.7439 8.61621","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartLineData1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-line-data-1',
    ref,
    icon: element,
  },
));

ChartLineData1Icon.displayName = 'ChartLineData1Icon';

export default ChartLineData1Icon;
